import { createContext, useContext } from 'react';
import { es } from './es';
import { en } from './en';
import { zh } from './zh';

export type Lang = 'es' | 'en' | 'zh';
export type Translations = typeof es;

const translations: Record<Lang, Translations> = { es, en, zh: zh as unknown as Translations };

export function getTranslations(lang: Lang): Translations {
  return translations[lang];
}

export interface I18nContextType {
  lang: Lang;
  setLang: (lang: Lang) => void;
  t: Translations;
}

export const I18nContext = createContext<I18nContextType>({
  lang: 'es',
  setLang: () => {},
  t: es,
});

export function useI18n() {
  return useContext(I18nContext);
}

export { es, en, zh };
